import { gql } from "gql";
import { ProductSwitchOffersQuery } from "gql/graphql";
import { apolloClient } from "./apolloClient";
import { trackTask } from "src/utils/monitoring/events/tasks";
import { getActiveUser } from "@noom/hive-auth";

export type ProductSwitchOfferQuery =
  ProductSwitchOffersQuery["productSwitchOffers"]["offers"][number];

export const PRODUCT_SWITCH_OFFERS_QUERY = gql(`
  query ProductSwitchOffers($accessCode: String) {
    productSwitchOffers(accessCode: $accessCode) {
      offers {
        productName
        switchOperation {
          saleItemId
          trialSaleItemId
          subscriptionModificationReason
          switchType {
            ... on ImmediateSwitch {
              billingCycleBehavior
              prorationBehavior
              trialType
            }
            ... on NextBillingCycleSwitch {
              revertBehavior
            }
          }
        }
      }
    }
  }
`);

export async function queryProductSwitchOffers(): Promise<
  ProductSwitchOfferQuery[]
> {
  const task = trackTask("QueryProductSwitchOffers");
  task.start();

  const activeUser = getActiveUser();

  if (!activeUser?.accessCode) {
    task.failed(new Error("User not authenticated"));
    return [];
  }

  const { accessCode } = activeUser;

  try {
    const result = await apolloClient.query({
      query: PRODUCT_SWITCH_OFFERS_QUERY,
      variables: { accessCode },
    });

    const offers = result.data?.productSwitchOffers?.offers ?? [];
    task.success({ offerCount: offers.length, accessCode });
    return offers;
  } catch (error: any) {
    task.failed(error, { accessCode });
    return [];
  }
}
